import { loadAppConfig } from './loadAppConfig';

loadAppConfig().then(() => {
    console.log('Config loaded, starting Tonkean');
    import('./main-split');
});
